import moment from 'moment'

export function daysSince(date?: string): number {
  if (!date) {
    return 0
  }

  console.log(moment(`${moment().format('MM/DD/yyyy')} 00:00:00`).diff(date, 'days'))

  return moment(`${moment().format('MM/DD/yyyy')} 00:00:00`).diff(date, 'days')
}
